import React from 'react';
import { Link } from 'react-router-dom';
import { FaTruck, FaUndo, FaShieldAlt, FaArrowRight } from 'react-icons/fa';
import useScrollAnimation from './useScrollAnimation';

const CallToAction = () => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.15 });

  return (
    <section 
      ref={sectionRef} 
      className={`cta-section ${isVisible ? 'is-visible' : ''}`}
      id="buy"
    >
      <div className="section-container">
        <div className="cta-card scroll-scale-up">
          <div className="cta-ambient-glow" />

          <div className="cta-content">
            <span className="section-eyebrow">Ready for Titanium?</span>
            <h2 className="cta-title">Upgrade to Peace i17 Air.</h2>
            <p className="cta-subtitle">
              Get $200–$650 in credit when you trade in an eligible smartphone. Plus 0% APR financing available for 24 months.
            </p>

            <div className="cta-buttons-row">
              <Link to="/products" className="apple-btn apple-btn-primary cta-main-btn">
                Order Peace i17 Air <FaArrowRight className="btn-icon-right" />
              </Link>
              <Link to="/products" className="apple-btn apple-btn-secondary">
                View All Products
              </Link>
            </div>

            {/* Value Props Bar */}
            <div className="cta-perks-grid">
              <div className="cta-perk-item">
                <div className="perk-icon-wrap">
                  <FaTruck />
                </div>
                <div className="perk-text">
                  <strong>Free Express Delivery</strong>
                  <span>Delivered securely in 2-3 business days</span>
                </div>
              </div>

              <div className="cta-perk-item">
                <div className="perk-icon-wrap">
                  <FaUndo />
                </div>
                <div className="perk-text">
                  <strong>14-Day Free Returns</strong>
                  <span>Hassle-free returns online or in-store</span>
                </div>
              </div>

              <div className="cta-perk-item">
                <div className="perk-icon-wrap">
                  <FaShieldAlt />
                </div>
                <div className="perk-text">
                  <strong>2-Year PeaceCare Warranty</strong>
                  <span>Comprehensive hardware and screen protection</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
